import { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import BlogCard from '../../components/BlogCard';
import { fetchBlogPosts } from '../../utils/fetchBlogPosts';
import { useI18n } from '../../i18n';
import { en, km } from './index.copy';

export default function Blog() {
  const [searchQuery, setSearchQuery] = useState('');
  const [blogPosts, setBlogPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { locale } = useI18n();
  const t = locale === 'km' ? km : en;

  useEffect(() => {
    const loadBlogPosts = async () => {
      const posts = await fetchBlogPosts(locale);
      setBlogPosts(posts);
      setLoading(false);
    };

    loadBlogPosts();
  }, [locale]);
  
  const filteredPosts = blogPosts.filter(post => 
    post.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Layout 
      title={t.title}
      description={t.description}
      canonicalPath="/blog"
    >
      <main>
        <section className="relative z-10">
          <div className="container mx-auto py-12 lg:py-14 xl:py-20 relative z-10">
            <div className="flex items-center justify-between gap-6 mb-6 lg:mb-10 flex-wrap">
              <h1 className="heading-large font-medium text-primary">{t.heading}</h1>
              
              <div className="relative">
                <span className="hidden lg:block absolute top-1/2 z-10 pl-2.5 -translate-y-1/2" style={{ color: '#000000' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24" className="w-9 h-9">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="m21 21-6-6m2-5c0 3.866-3.134 7-7 7-3.86599 0-7-3.134-7-7 0-3.86599 3.13401-7 7-7 3.866 0 7 3.13401 7 7Z"></path>
                  </svg>
                </span>
                <input 
                  className="input lg:!pl-14 body-large bg-opacity-10 !border-none !rounded-sm bg-black"
                  placeholder={t.searchPlaceholder}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  style={{ color: '#000000' }}
                />
              </div>
            </div>

            {loading ? (
              <div className="text-center py-20">
                <h3 className="heading-medium mb-4">{t.loading}</h3>
              </div>
            ) : filteredPosts.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 mb-8 lg:mb-14">
                {filteredPosts.map(post => (
                  <BlogCard key={post.id} post={post} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <h3 className="heading-medium mb-4">{t.noResults}</h3>
                <p className="body-normal">{t.noResultsHint}</p>
              </div>
            )}
          </div>
        </section>
      </main>
    </Layout>
  );
} 